/* eslint-disable */

import { getDistance } from './helpers';
import { store } from '../stores/mainStore';
import { integration } from '../integration';

var lastTimeSecs = 0;
var numDiceStopped = 0;

export function update(time, delta) {
	const m = window.manager;
	if (!m) {
		console.warn('game running, should be stopping.');
		return;
	}

	const roll3d = (d, i, movePixels) => {
		const distance = getDistance(d.diceSprite.x, d.diceSprite.y, d.lastPosition.x, d.lastPosition.y);
		if (d.frameNum >= 0) {
			if (distance > movePixels) {
				d.lastPosition.x = d.diceSprite.x;
				d.lastPosition.y = d.diceSprite.y;
				if (++d.frameNum >= 9) d.frameNum = 0;
				//d.diceImage.setTexture(store.custom.dice + '_dice3D_sheet', i * 9 + d.frameNum);
				d.diceImage.setTexture('dice3D_sheet', i * 9 + d.frameNum);
			}
		}
	}

	if (m.diceStatus === 'introToCup') {
		m.diceHand.dice.forEach((d, i) => roll3d(d, i,  16 * m.scaleFactor))
		return;
	}

	if (m.diceStatus === 'pokerRush3D') {
		m.diceHand.dice.forEach((d, i) => roll3d(d, i, 32 * m.scaleFactor))
		return;
	}

	if (m.diceStatus === 'launching') {
		if (m.diceHand.diceLaunched < 9) {
			var secs = time / 100;
			if (secs - lastTimeSecs >= 0.15) {
				lastTimeSecs = secs;
				if (m.diceHand.diceLaunched === 0) {
					if (!m.diceReceived) {
						return;
					}
				}
				if (m.diceHand.diceLaunched% 2 === 0) {
					m.playHaptic('haptic_heavyImpact');
				}
				m.diceHand.launchNextDice();
				m.diceHand.diceLaunched++;
			}
		}
	}
	if (m.diceStatus === 'launching') {
		for (let i = 0; i < m.diceHand.diceLaunched; i++) {
			let d = m.diceHand.dice[i];
			if (!d.locked) {
				if(d.frameNum >= 0) {
					roll3d(d, i, 16 * m.scaleFactor);
				} else { 
					d.diceSprite.setVelocity(0, 0);
					d.diceSprite.body.angularVelocity = 0;
				}

				var minVelocity = 1.5; // 4.0;
				if (
					Math.abs(d.diceSprite.body.velocity.x) < minVelocity &&
					Math.abs(d.diceSprite.body.velocity.y) < minVelocity
				) {
					d.lastPosition.x = d.diceSprite.x;
					d.lastPosition.y = d.diceSprite.y;
					d.diceSprite.body.moves = false;
					d.diceSprite.setVelocity(0, 0);
					d.diceSprite.setAngularVelocity(0);
					d.frameNum = -1;
					/* var face = d.currentFace;
					var num = i * 6 + face;
					d.diceImage.setTexture(store.custom.dice + '_dice2D_sheet');
					d.diceImage.setFrame(num); */
					d.diceImage.setTexture('dice2D_sheet');
					d.diceImage.setFrame(d.currentFace);
					d.diceSprite.setScale(m.dice2DSmallScale);
				} else {
					var collideVelocity = 10;
					if (Math.abs(d.diceSprite.body.velocity.y) < collideVelocity) {
						d.diceSprite.body.collisionFilter.group = 0;
						d.diceSprite.body.collisionFilter.mask = m.diceHand.collisionMask;
					}
				}
			}
		}
		if (m.diceHand.diceLaunched >= 9) {
			numDiceStopped = 0;
			for (let i = 0; i < 9; i++) 
				if (m.diceHand.dice[i].frameNum < 0) 
					numDiceStopped++;
			if (numDiceStopped >= 9) {
				m.diceStatus = 'stopped';
				if(store.activeMatch.matchId !== 'intro')
					m.ui.fadeGoalBanner(true);
				for (let i = 0; i < 9; i++) {
					let d = m.diceHand.dice[i];
					d.diceSprite.body.moves = false;
					d.diceSprite.body.collisionFilter.group = -1;
					d.diceSprite.body.collisionFilter.mask = 0;
					var thisTween = m.scene.tweens.add({
						targets: [d.diceSprite],
						x: d.homePosition.x,
						y: d.homePosition.y,
						scaleX: m.diceBigScale,
						scaleY: m.diceBigScale,
						angle: 0,
						ease: 'Power0',
						delay: 0, //500,
						duration: 420,
						repeat: 0,
						callbackScope: thisTween,
						completeDelay: 0,
						onComplete: function (tween, target, num) {
							if (num === 8) {
								console.log('dice resolved');
								m.gameState.state = 'idle';
								m.diceStatus = 'resolved';
								m.diceHand.resetDicePriority();
						
								if(store.pokerRush) {
									gameSetTimeout(m.diceHand.doPokerRushHand, 500);
								} else {
									m.allDiceResolved();
								}
							}
						},
						onCompleteParams: [d.diceNum],
						onCompleteScope: thisTween,
					});
				}
			}
		}
	}
}
